<template>
  <div class="etiology-pathogenesis">
    <div class="mk2">
      <div class="body">
        <div class="block mk1">
          <!-- <div class="header-title">
            <div class="bty only-one_1">黄色背景：症状对应唯一的辨证</div>
            <div class="bty only-one_2">
              绿色背景：串联链路中症状对应的非唯一辨证
            </div>
            <div class="bty only-one_3">
              蓝色背景：单独线路中内因或外因导致的辨证
            </div>
          </div> -->
          <div class="table-block" id="part1">
            <Table border class="table_right" :columns="columns3" :data="list3" :max-height="maxHeight"
              :cellClassName="cellClassName2"></Table>
            <Table border class="table_left" :columns="columns1" :data="list1" :cellClassName="cellClassName"
              :span-method="arraySpanMethod" :max-height="maxHeight"></Table>
          </div>
        </div>
        <div id="part2" class="llt" :class="{ fullScreen: fullScreen }">
          <div class="tool" @click="fullScreen = !fullScreen">
            <Icon v-if="fullScreen" type="md-close" />
            <Icon v-else type="md-expand" />
          </div>
          <iframe id="myIframe" :src="flowUrl()" frameborder="0" width="100%" height="100%"></iframe>
        </div>
        <generateAnalysisFile id="part3" :data="dataInfo" />
        <div id="part4" class="block ydx">
          <div class="b-title">易懂性病因病机</div>
          <div class="line-group">
            <div class="line-item" v-for="(g_item, g_index) in dataInfo.easyCausePathogenesisList" :key="g_index">
              <div class="line-title">
                链路{{ g_item.group.replace(/,/g, "、") }}
              </div>
              <div class="line-body">
                <div v-for="(item, index) in g_item.easyCausePathogenesis" :key="index">
                  <div :class="{ red: index == 2 }">{{ clearStr(item) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="line-group">
          <div class="line-item" v-for="(item, index) in lineGroup" :key="index">
            <div class="line-title">链路{{ item.id }}</div>
            <div class="line-body" v-html="item.lineStr"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generateAnalysisFile from "./generateAnalysisFile/index.vue";
import DownloadExcel from "./downloadExcel.js";
import { mapGetters } from "vuex";
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    isFocus: {
      //是否自动聚焦
      type: Boolean,
      default: true,
    },
  },
  components: {
    generateAnalysisFile,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    dataInfo(newValue, oldValue) {
      this.init();
    },
  },
  data() {
    return {
      fullScreen: false,
      isError: false,
      list1: [],
      columns1: [
        {
          title: "症状",
          key: "dsName",
          width: 120,
        },
        {
          title: "辨证",
          key: "dx",
          minWidth: 170,
        },
        // {
        //   title: "典型病机",
        //   key: "dxbj",
        //   width: 170,
        // },
        // {
        //   title: "典型病因",
        //   key: "dxby",
        //   width: 170,
        // },
        // {
        //   title: "非典型",
        //   key: "fdx",
        //   minWidth: 170,
        // },
        // {
        //   title: "非典型病机",
        //   key: "fdxbj",
        //   width: 170,
        // },
        // {
        //   title: "非典型病因",
        //   key: "fdxby",
        //   width: 170,
        // },
      ],
      list3: [],
      columns3: [
        {
          title: "木",
          key: "木",
          minWidth: 120,
        },
        {
          title: "火",
          key: "火",
          minWidth: 120,
        },
        {
          title: "土",
          key: "土",
          minWidth: 120,
        },
        {
          title: "金",
          key: "金",
          minWidth: 120,
        },
        {
          title: "水",
          key: "水",
          minWidth: 120,
        },
      ],
      lineGroup: [],
      maxHeight: "calc(100vh - 100px)",
    };
  },
  methods: {
    flowUrl() {
      return this.uconfig.flowUrl + "?r=" + Math.random();
    },
    clearStr(str) {
      return str ? str.replace(/\[|\]/g, "") : "";
    },
    formatLines(list) {
      let group = [];
      list.forEach((item) => {
        let i = group.find((i) => i.id === item.group);
        if (i) {
          i.list.push(item);
        } else {
          group.push({
            id: item.group,
            list: [item],
          });
        }
      });
      group.forEach((i) => {
        let arr = [];
        i.list.map((j) => {
          arr.push((j.transOrder || "") + j.dialecticName);
          if (j.pathogenesisList && j.pathogenesisList.length) {
            let d = j.pathogenesisList.join("<br/>");
            arr.push(`<span class="red">${d}</span>`);
          }
        });
        i.lineStr = arr.join("➸");
      });
      this.lineGroup = group;
    },
    setWxTableData(list) {
      let grouped = list.reduce((acc, item) => {
        let e = acc.find((i) => i.name === item.name);
        if (!e) {
          acc.push({
            name: item.name,
            items: [item],
          });
        } else {
          e.items.push(item);
        }
        return acc;
      }, []);

      // 排序
      grouped.forEach((i) => {
        i.items.sort((a, b) => {
          return a.transOrder ? a.transOrder.localeCompare(b.transOrder) : 0;
        });
      });

      let length = Math.max(...grouped.map((i) => i.items.length));
      let tableDatas = [];
      for (let i = 0; i < length; i++) {
        let obj = { cellClassName: {} };
        grouped.forEach((item) => {
          obj[item.name] = item.items[i]
            ? (item.items[i].transOrder || "") + item.items[i].dialecticsName
            : "";

          let onlyOne = item.items[i] ? item.items[i].onlyOne || "" : ""; //用于标颜色
          obj.cellClassName[item.name] = "only-one_" + onlyOne; //用于标颜色
        });
        tableDatas.push(obj);
      }
      this.list3 = tableDatas;
      this.sendDiseaseToPad();
      return tableDatas;
    },

    // 发送五行图数据到pad
    sendDiseaseToPad() {
      if(!this.info.patientInfo) return;
      let patientInfo = this.info.patientInfo;
      // 发送症状到pad
      let objSend = {
        patientAge: patientInfo.patientAge,
        patientSex: patientInfo.patientSex,
        patientCode: patientInfo.patientCode,
        patientName: patientInfo.patientName,
        cellphoneNo: this.common.phone(patientInfo.cellphoneNo),
        hospitalCode: this.userInfo.hosptialCode, //医馆编码
        hospitalName: this.userInfo.hosptialName,
        messageData: JSON.stringify(this.list3),
        messageType: 2, // 1 症状确认消息 2 五行辩证图 3 提交处方关闭五行辩证图
      };
      this.api2("sendingSymptoms", objSend).then((res) => {
        // this.$Message.success(res.result);
      });
    },

    formatList(list, arr, field) {
      let groupIdList = {};
      list.forEach((i) => {
        if (i.groupId == -1) {
          let item = arr.find((j) => j.dsName == i.dsName);
          let obj = {
            transOrder: i.transOrder || "",
            dialecticsName: i.dialecticsName,
            onlyOne: i.onlyOne,
            pathogenesis: [i.pathogenesis],
          };
          if (item) {
            if (item[field]) {
              let d = item[field].find(
                (j) => j.dialecticsName == i.dialecticsName
              );
              if (!d) {
                item[field].push(obj);
              } else {
                d.pathogenesis.push(i.pathogenesis);
              }
            } else {
              item[field] = [obj];
            }
          } else {
            let etiologyBottomReason =
              i.etiologyBottomReason && i.etiologyBottomReason.length
                ? i.etiologyBottomReason
                  .map((i) =>
                    i
                      .replace(/(\\|"|&)/g, "")
                      .replace(/\[/, "(")
                      .replace(/\]/, ")")
                  )
                  .join("，")
                : "";
            let o = {
              dsName: i.dsName,
            };
            o[field + "_etiologyBottomReason"] = etiologyBottomReason;
            o[field] = [obj];
            arr.push(o);
          }
        } else {
          let obj = groupIdList[i.groupId];
          if (obj) {
            obj.push(i);
          } else {
            groupIdList[i.groupId] = [i];
          }
        }
      });
      // console.log("===>", JSON.parse(JSON.stringify(arr)));

      for (const key in groupIdList) {
        if (Object.hasOwnProperty.call(groupIdList, key)) {
          const li = groupIdList[key];
          let dsNames = [...new Set(li.map((j) => j.dsName))].join("，");
          li.forEach((i) => {
            let item = arr.find((j) => j.dsName == dsNames);
            let obj = {
              dialecticsName: i.dialecticsName,
              onlyOne: i.onlyOne,
            };
            if (item) {
              if (item[field]) {
                !item[field].find(
                  (j) => j.dialecticsName == i.dialecticsName
                ) && item[field].push(obj);
              } else {
                item[field] = [obj];
              }
            } else {
              let o = {
                dsName: dsNames,
              };
              o[field] = [obj];
              arr.push(o);
            }
          });
        }
      }
      return arr;
    },

    formatData(dx, fdx) {
      let arr = [];
      this.formatList(dx, arr, "dx");
      this.formatList(fdx, arr, "fdx");

      this.list1 = [];
      arr.forEach((i) => {
        let l1 = i.dx ? i.dx.length : 0;
        let l2 = i.fdx ? i.fdx.length : 0;

        this.list1 = arr.map((i) => {
          return {
            dsName: i.dsName,
            dx: (i.dx || i.fdx).map((j) => j.dialecticsName).join("，"),
          }
        });

        return;
        let length = Math.max(l1, l2);
        for (let j = 0; j < length; j++) {
          let onlyOneDx = i.dx ? (i.dx[j] ? i.dx[j].onlyOne : 0) : 0;
          let onlyOneFdx = i.fdx ? (i.fdx[j] ? i.fdx[j].onlyOne : 0) : 0;
          let obj = {
            dsName: i.dsName,
            dx: i.dx
              ? i.dx[j]
                ? i.dx[j].transOrder + i.dx[j].dialecticsName
                : ""
              : "",
            fdx: i.fdx
              ? i.fdx[j]
                ? i.fdx[j].transOrder + i.fdx[j].dialecticsName
                : ""
              : "",
            dxbj: i.dx ? (i.dx[j] ? i.dx[j].pathogenesis.join("。") : "") : "", //病机
            fdxbj: i.fdx
              ? i.fdx[j]
                ? i.fdx[j].pathogenesis.join("。")
                : ""
              : "",

            dxby: i.dx_etiologyBottomReason, //病因
            fdxby: i.fdx_etiologyBottomReason,

            onlyOneDx,
            onlyOneFdx,
            cellClassName: {
              dx: "only-one_" + onlyOneDx,
              fdx: "only-one_" + onlyOneFdx,
            },
          };
          this.list1.push(obj);
        }
      });
    },
    // tablei1单元格添加颜色
    cellClassName({ row, column, rowIndex, columnIndex }) {
      let className = "";
      if (column.label == "典型" && row.onlyOneDx) {
        className = "only-one_" + row.onlyOneDx;
      } else if (column.label == "非典型" && row.onlyOneFdx) {
        className = "only-one_" + row.onlyOneFdx;
      }
      return className;
    },

    // tablei2单元格添加颜色
    cellClassName2({ row, column, rowIndex, columnIndex }) {
      return "only-one_" + row[column.label + "onlyOne"];
    },

    // 合并表格方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并相同dsName的表格
      if ([0, 3, 6].includes(columnIndex)) {
        let rowspan = 0;
        let colspan = 1;
        if (rowIndex === 0) {
          rowspan = this.list1.filter((i) => i.dsName === row.dsName).length;
        } else {
          let prevRow = this.list1[rowIndex - 1];
          if (prevRow.dsName === row.dsName) {
            rowspan = 0;
          } else {
            rowspan = this.list1.filter((i) => i.dsName === row.dsName).length;
          }
        }
        return { rowspan, colspan };
      }
    },

    downloadExcel() {
      let d = new DownloadExcel(
        this.list1,
        this.list3,
        this.columns1,
        this.columns3,
        this.lineGroup,
        this.info
      );
      d.download();
    },

    // 发送消息给子窗口
    sendMessage() {
      let dialecticMindMap = this.dataInfo.dialecticMindMap;
      console.log("==========>",dialecticMindMap);
      let node = document.getElementById("myIframe");
      node.contentWindow.postMessage(dialecticMindMap, "*");
    },

    // 监听子窗口消息
    listenerMessage() {
      window.addEventListener("message", (event) => {
        // console.log("收到来自子窗口的消息：", event.data);
        this.sendMessage();
      });
    },

    init() {
      this.list1 = [];
      this.list3 = [];
      let { dx, fdx, wx, transPathogenesisList, dialecticMindMap } =
        this.dataInfo;
      this.formatLines(transPathogenesisList);
      this.formatData(dx, fdx);
      this.setWxTableData(wx);

      // 不需要讲解病因病机 窗口自动滚动到易懂性病因病机
      if (this.dataInfo.explainType && !this.isDetail && this.isFocus) {
        setTimeout(() => {
          this.$el.querySelector(".ydx").scrollIntoView({ behavior: "smooth" });
        }, 300);
      }

      this.listenerMessage();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.etiology-pathogenesis {
  line-height: 1.5em;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  :deep {
    .ivu-table-cell {
      padding: 0 10px;
      line-height: 26px;
    }
  }

  .mk1 {
    .header {
      margin-bottom: 15px;
    }
  }

  .mk2 {
    height: 100%;
    overflow-y: auto;
  }

  .table-header {
    display: flex;
    justify-content: space-between;

    .label {
      font-weight: bold;
    }

    .other {
      font-size: 12px;
      opacity: 0.6;
    }
  }

  .button-group {
    text-align: center;
    margin-bottom: 15px;
  }

  .body {
    height: 100%;

    .header-title {
      margin-bottom: 15px;
      line-height: 20px;

      &>div {
        display: inline-block;
        margin-right: 10px;
        padding: 0 15px;
      }
    }

    .table-block {
      height: 100%;
      width: 100%;
      overflow-y: auto;
      position: relative;
      display: flex;
      padding-bottom: 20px;

      .table_left {
        width: 950px;
        flex-shrink: 0;
      }

      .table_right {
        width: 100%;
        margin-right: 20px;
        margin-bottom: 15px;
      }
    }

    @media screen and (max-width: 1600px) {
      .table-block {
        display: block;
        height: auto;

        .table_left {
          width: 100%;
          margin-bottom: 15px;
        }

        .table_right {
          width: 100%;
        }
      }
    }
  }

/*
  :deep {
    .only-one_1 {
      background: #fac006 !important;
      color: #000;
    }

    .only-one_2 {
      background: #91ce51 !important;
      color: #000;
    }

    .only-one_3 {
      background: #02aeef !important;
      color: #000;
    }
  }
*/

  .log {
    padding-top: 10px;
    height: 45px;
    overflow: hidden;
    font-size: 13px;
    margin-bottom: 15px;
    position: relative;

    .copy-btn {
      position: absolute;
      right: 15px;
      top: 10px;
      cursor: pointer;
      z-index: 10;
    }

    .log-item {
      opacity: 0.3;
    }

    &.log-show {
      height: auto;
      padding: 15px;

      .log-item {
        opacity: 1;
      }
    }

    .log-body {
      overflow-y: auto;
      font-size: 14px;
      line-height: 2em;
    }
  }

  .log-head {
    display: inline-block;
    cursor: pointer;
    opacity: 0.6;
    text-align: center;
    width: 100%;
    padding: 5px 0;
  }

  .ydx .line-group {
    .line-item {
      white-space: wrap;
    }
  }

  .line-group {
    .line-item {
      padding-bottom: 10px;
      white-space: nowrap;
    }

    .line-title {
      font-weight: bold;
      padding-bottom: 5px;
    }

    .line-body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }

  .ydx {
    line-height: 2em;
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;

    .line-group .line-body {
      display: block;
    }
  }

  .error {
    padding-top: 10px;
  }

  .mk1 {
    margin-bottom: 15px;
  }

  .b-title {
    font-weight: bold;
    font-size: 15px;
    padding-bottom: 8px;
  }

  .b-content {
    line-height: 2em;
  }

  .llt {
    height: 600px;
    position: relative;

    &.fullScreen {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background: #fff;
    }

    .tool {
      font-size: 24px;
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }

  #myIframe {
    border: 1px solid #ddd;
  }
}
</style>